import React from 'react';
import { Grid, IconButton, Tooltip } from '@mui/material';

import { useRo } from '../../hooks/useRo';
import UploadDialog from '../../layouts/UploadDialog';
import UploadDialogWithPreview from '../../layouts/UploadDialogWithPreview';
import { READ_ONLY } from '../../utils/constants';
import { capitalizeIt } from '../../utils/utils';
import FilesDialog from '../core/s3/FilesDialog';

import ConfirmDialog from './ConfirmDialog';
import DynamicIcon from './DynamicIcon';

const GridActions = ({
  row,
  theme,
  editRow,
  showEdit = true,
  setDelete,
  deleteRow,
  setConfirmDialog,
  viewRow,
  confirmDelType,
  confirmDialog,
  confirmData,
  showVisibility = true,
  showDelete = true,
  uploadFiles,
  uploadProps,
  showUpload = false,
  viewFiles,
  viewTooltip = 'View Files',
  uploadTooltip = 'Upload Files',
  showUploadWithPreview = false,
}) => {
  const [isReadOnly, roleName] = useRo();

  return (
    <Grid container>
      {showVisibility && row?.is_active && (
        <Grid item>
          <Tooltip title="View">
            <IconButton
              onClick={viewRow}
              style={{ color: theme.palette.dark.main }}
            >
              <DynamicIcon iconName={'Visibility'} />
            </IconButton>
          </Tooltip>
        </Grid>
      )}
      {(row?.is_active === undefined || row?.is_active) &&
        roleName !== READ_ONLY &&
        !isReadOnly &&
        showEdit && (
          <Grid item>
            <Tooltip title="Modify">
              <IconButton
                onClick={editRow}
                style={{ color: theme.palette.primary.main }}
              >
                <DynamicIcon iconName={'Edit'} />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
      {row?.is_active !== undefined &&
        showDelete &&
        roleName !== READ_ONLY &&
        !isReadOnly && (
          <Grid item>
            <Tooltip title={row.is_active ? 'Delete' : 'Restore'}>
              <IconButton
                onClick={setDelete}
                style={{
                  color: row.is_active
                    ? theme.palette.error.main
                    : theme.palette.grey_500.main,
                }}
              >
                {row.is_active ? (
                  <DynamicIcon iconName={'Delete'} />
                ) : (
                  <DynamicIcon iconName={'RestoreFromTrash'} />
                )}
              </IconButton>
            </Tooltip>
            <ConfirmDialog
              deleteRow={deleteRow}
              setConfirmDialog={setConfirmDialog}
              title={`Confirm ${capitalizeIt(confirmDelType)}`}
              confirmDialog={confirmDialog}
              confirmData={confirmData}
              confirmDelType={confirmDelType}
            />
          </Grid>
        )}
      {showUpload && (
        <>
          <Grid item>
            <Tooltip title={uploadTooltip}>
              <IconButton
                onClick={uploadFiles}
                style={{ color: theme.palette.primary.dove_gray }}
              >
                <DynamicIcon iconName={'CloudUpload'} />
              </IconButton>
            </Tooltip>
            <UploadDialog {...uploadProps} />
          </Grid>
          <Grid item>
            <Tooltip title={viewTooltip}>
              <IconButton
                onClick={viewFiles}
                style={{ color: theme.palette.secondary.main }}
              >
                <DynamicIcon iconName={'CloudDone'} />
              </IconButton>
            </Tooltip>
            <FilesDialog {...uploadProps} />
          </Grid>
        </>
      )}
      {showUploadWithPreview && (
        <>
          <Grid item>
            <Tooltip title={uploadTooltip}>
              <IconButton
                onClick={uploadFiles}
                style={{ color: theme.palette.primary.dove_gray }}
              >
                <DynamicIcon iconName={'CloudUpload'} />
              </IconButton>
            </Tooltip>
            <UploadDialogWithPreview {...uploadProps} />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default GridActions;
